<template>
  <div class="campaign-child">
    <div class="news-list mt-5">
      <v-row>
        <Card
          v-for="article in news"
          :key="article.ID"
          :title="article.title.rendered"
          :date="article.date"
          :image="article.thumbnail"
          :link="{ name: 'article', params: {slug: decodeURIComponent(article.slug)} }"
        ></Card>
      </v-row>
    </div>

    <Pagination v-model="page"></Pagination>
  </div>
</template>

<script>
import { formatDate } from '@/helpers.js'
import Pagination from '@/components/Utils/Pagination.vue'
import Card from '@/components/Card.vue'

export default {
  name: 'CampaignNews',
  components: { Pagination, Card },
  data() {
    return { page: 1 }
  },

  mounted () {
    this.fetchNews()
  },

  methods: {
    formatDate,

    fetchNews () {
      this.$store.commit('setNews', [])
      if (this.campaign.news && this.campaign.news.length > 0) {
        this.$store.commit('setLoading', true)

        let getNews = this.$route.name === 'campaign-news' ?
          this.$store.dispatch('getNews', { page: this.page, ids: this.campaign.news }) :
          this.$store.dispatch('getNCCampaignNews', { page: this.page, ids: this.campaign.news })

        getNews.then(() => {
          this.$store.commit('setLoading', false)
        }).catch(() => {
          this.$store.commit('setLoading', false)
          this.$store.commit('showAlert', { type: 'error', message: 'Грешка при зареждането на новините.' })
        })
      }
    },

    articleLink (article) {
      if (this.$route.name === 'campaign-news') {
        return {
          name: 'article',
          params: { slug: decodeURIComponent(article.slug) }
        }
      } else {
        return {
          name: 'nc-campaign-article',
          params: { articleSlug: decodeURIComponent(article.slug) }
        }
      }
    }
  },

  computed: {
    campaign () {
      return this.$route.name === 'campaign-news'
        ? this.$store.getters.campaign
        : this.$store.getters.ncCampaign
    },

    news () {
      return this.$store.getters.news
    }
  },

  watch: {
    page: 'fetchNews'
  }
}
</script>
